export default __webpack_public_path__ + "static/media/img_company_header30.af02e38c.png";